import { useContext } from 'react';
import { assert } from 'ts-essentials';

import AnalyticsProxyContext, { type AnalyticsProxyCtx } from './context';

const useAnalyticsProxyContext = (): AnalyticsProxyCtx => {
  const ctx = useContext(AnalyticsProxyContext);

  assert(ctx, '`AnalyticsContext` not found in React tree');

  return ctx;
};

export default useAnalyticsProxyContext;
